import { CLEAR_STATE, LOADER, MODAL_LOADER, SAVE_FEEDBACK, ERROR, SUCCESS } from './types';


export const setLoader = (payload) => {
  return {
    type: LOADER,
    payload
  }
}


export const setModalLoader = (payload) => {
  return {
    type: MODAL_LOADER,
    payload
  }
}

export const saveFeedback = (payload) => {
  return {
    type: SAVE_FEEDBACK,
    payload
  }
}

export const clearReducerState = () => {
  return {
    type: CLEAR_STATE
  }
}


export const setErrorMsg = (payload) => {
  return {
    type: ERROR,
    payload
  }
}


export const setSuccessMsg = (payload) => {
  return {
    type: SUCCESS,
    payload
  }
}
